import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';
import { APPLICATION_ROUTE_NAMES } from '../../../../routes/dashboard/settings/integrationapps/applicationCatalog';

const settings = accountId => ({
  parentNav: 'settings',
  sortAlphabetically: true,
  routes: [
    'agent_list',
    'attributes_list',
    'automation_list',
    'bulk_actions_list',
    'bulk_actions_report',
    'auditlogs_list',
    'billing_settings_index',
    'canned_list',
    'agent_bot_management_list',
    'closingreasons_list',
    'general_settings_index',
    'general_settings',
    'labels_list',
    'macros_edit',
    'macros_new',
    'macros_wrapper',
    'settings_applications_integration',
    'settings_applications_webhook',
    'settings_applications',
    'settings_inbox_finish',
    'settings_inbox_list',
    'settings_inbox_new',
    'settings_inbox_show',
    'settings_inbox',
    'settings_inboxes_add_agents',
    'settings_inboxes_page_channel',
    'settings_integrations_dashboard_apps',
    'settings_integrations_webhooks_send_message',
    'settings_integrations_webhooks_send_message_logs',
    'settings_integrations_integration',
    'settings_integrations_webhook',
    'settings_integrations',
    'settings_applications_webhook',
    'settings_applications_dashboard_apps',
    'settings_applications_cadence',
    'settings_applications_assistent',
    'settings_applications_syonet',
    'settings_teams_add_agents',
    'settings_teams_edit_finish',
    'settings_teams_edit_members',
    'settings_teams_edit',
    'settings_teams_finish',
    'settings_teams_list',
    'settings_teams_new',
    'cadencia_settings_index',
    'events_settings_index',
    'virtual_assistants_list',
    'virtual_assistants_list',
    'settings_opportunity_pipelines_list',
    'settings_opportunity_pipelines_new',
    'settings_opportunity_pipelines_new_users',
    'settings_opportunity_pipelines_new_inboxes',
    'settings_opportunity_pipelines_new_stages',
    'settings_opportunity_pipelines_new_loss_reasons',
    'settings_opportunity_pipelines_new_finish',
    'settings_opportunity_pipelines_edit',
    'settings_opportunity_pipelines_users',
    'settings_opportunity_pipelines_inboxes',
    'settings_opportunity_pipelines_stages',
    'settings_opportunity_pipelines_loss_reasons',
    'settings_opportunity_pipelines_finish',
    'embedded_builder',
    'whatsapp',
  ],
  menuItems: [
    {
      icon: 'star-emphasis',
      label: 'APPLICATIONS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/settings/applications`),
      toStateName: 'settings_applications',
      featureFlag: FEATURE_FLAGS.INTEGRATIONS,
      accountTypes: ['account', 'subaccount', 'parent_account'],
      activeOnRoutes: APPLICATION_ROUTE_NAMES,
      // Product requirement: Applications always renders last, regardless of
      // alphabetical order, since it's the catch-all for low frequency screens.
      pinToEnd: true,
    },
    {
      icon: 'robot',
      label: 'VIRTUAL_ASSISTANTS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/settings/virtual-assistants`),
      toStateName: 'virtual_assistants_list',
      featureFlag: FEATURE_FLAGS.VIRTUAL_ASSISTANTS,
      accountTypes: ['account', 'subaccount'],
    },
    {
      icon: 'chat-multiple',
      label: 'CANNED_RESPONSES',
      hasSubMenu: false,
      toState: frontendURL(
        `accounts/${accountId}/settings/canned-response/list`
      ),
      toStateName: 'canned_list',
      featureFlag: FEATURE_FLAGS.CANNED_RESPONSES,
      accountTypes: ['account', 'subaccount'],
    },
    {
      icon: 'code',
      label: 'CUSTOM_ATTRIBUTES',
      hasSubMenu: false,
      toState: frontendURL(
        `accounts/${accountId}/settings/custom-attributes/list`
      ),
      toStateName: 'attributes_list',
      featureFlag: FEATURE_FLAGS.CUSTOM_ATTRIBUTES,
      accountTypes: ['account', 'subaccount'],
    },
    {
      icon: 'automation',
      label: 'AUTOMATION',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/settings/automation/list`),
      toStateName: 'automation_list',
      featureFlag: FEATURE_FLAGS.AUTOMATIONS,
      accountTypes: ['account', 'subaccount'],
    },
    {
      icon: 'builder-icon',
      label: 'EMBEDDED_BUILDER',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/embedded-builder`),
      toStateName: 'embedded_builder',
      accountTypes: ['account', 'subaccount'],
    },
    {
      icon: 'mail-inbox-all',
      label: 'INBOXES',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/settings/inboxes/list`),
      toStateName: 'settings_inbox_list',
      featureFlag: FEATURE_FLAGS.INBOX_MANAGEMENT,
      accountTypes: ['account', 'subaccount'],
    },
    {
      icon: 'megaphone',
      label: 'CAMPAIGNS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/campaigns/whatsapp`),
      toStateName: 'whatsapp',
      featureFlag: FEATURE_FLAGS.CAMPAIGNS,
      accountTypes: ['account', 'subaccount', 'parent_account'],
    },
    {
      icon: 'briefcase',
      label: 'ACCOUNT_SETTINGS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/settings/general`),
      toStateName: 'general_settings_index',
      accountTypes: ['account', 'subaccount', 'parent_account'],
    },
    {
      icon: 'briefcase',
      label: 'OPPORTUNITY_PIPELINES',
      hasSubMenu: false,
      opportunityPipelinesManagement: true,
      toState: frontendURL(
        `accounts/${accountId}/settings/opportunity-pipelines/list`
      ),
      toStateName: 'settings_opportunity_pipelines_list',
      accountTypes: ['account', 'subaccount'],
    },
    {
      icon: 'flash-settings',
      label: 'MACROS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/settings/macros`),
      toStateName: 'macros_wrapper',
      featureFlag: FEATURE_FLAGS.MACROS,
      accountTypes: ['account', 'subaccount'],
    },
    {
      icon: 'tag',
      label: 'LABELS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/settings/labels/list`),
      toStateName: 'labels_list',
      featureFlag: FEATURE_FLAGS.LABELS,
      accountTypes: ['account', 'subaccount'],
    },
    {
      icon: 'people-team',
      label: 'TEAMS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/settings/teams/list`),
      toStateName: 'settings_teams_list',
      featureFlag: FEATURE_FLAGS.TEAM_MANAGEMENT,
      accountTypes: ['account', 'subaccount'],
    },
    {
      icon: 'people',
      label: 'AGENTS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/settings/agents/list`),
      toStateName: 'agent_list',
      featureFlag: FEATURE_FLAGS.AGENT_MANAGEMENT,
      accountTypes: ['account', 'subaccount', 'parent_account'],
    },
  ],
});

export default settings;
